///
/// EarthBrowser
///
/// Created by Matt Giger on 8/18/2024
/// Copyright (c) 2024 Geodata Labs
///

import { trig } from "@stovokor/math/math"
import { vec2, vec3 } from "@stovokor/math/vector"

export class TileId {
	public static key(z: number, y: number, x: number): string {
		return z + '_' + y + '_' + x
	}

	readonly key: string

	constructor(readonly z: number, readonly y: number, readonly x: number) {
		 this.key = z + '_' + y + '_' + x
	}

	public get invIndex(): vec3 {
		const invy = (1 << this.z) - this.y - 1
		return new vec3(this.x, invy, this.z)
	}

	public get parent(): TileId {
		return new TileId(this.z-1, this.y >> 1, this.x >> 1)
	}

	public get levelCount(): number {
		return 1 << (this.z * 2 + 1)
	}

	public get childIndex(): number {
		return (this.y % 2) << 1 | (this.x % 2)
	}

	public get children(): TileId[] {
		const z1 = this.z + 1
		const y2 = this.y << 1
		const x2 = this.x << 1
		return [
			new TileId(z1, y2, x2),
			new TileId(z1, y2, x2 + 1),
			new TileId(z1, y2 + 1, x2),
			new TileId(z1, y2 + 1, x2 + 1)
		]
	}

	public get origin(): vec2 {
		const rows = 1 << this.z
		const delta = trig.pi / rows
		return new vec2(this.x * delta - trig.pi, trig.half_pi - this.y * delta)
	}

	public get delta(): vec2 {
		const rows = 1 << this.z
		const delta = trig.pi / rows
		return new vec2(delta, -delta)
	}
}
